const defaultBlinds = [
    { small: 10, big: 20 },
    { small: 20, big: 40 },
    { small: 30, big: 60 },
    { small: 50, big: 100 },
    { small: 75, big: 150 },
    { small: 100, big: 200 },
    { small: 150, big: 300 },
    { small: 200, big: 400 },
    { small: 300, big: 600 },
    { small: 500, big: 1000 }
];

export default defaultBlinds;